import styled from "styled-components";
import { Colors } from "../../../../assets/styles/StyleTypes";

type RowProps = {
  className?: string;
};
export const Row = styled.div<RowProps>`
  cursor: ${(props) =>
    props.className !== "cursorPointer" ? "pointer" : "default"};
  background-color: ${(props) => props.theme.colors.backgroundTable};
  padding: 8px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  &#details-equipment {
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 150px 120px;
    grid-template-areas: "title data1 hour";
    column-gap: 12px;
    align-items: center;

    > div {
      width: auto;
      min-width: 0;
    }
  }

  &:nth-child(even),
  &.even {
    background-color: transparent;
  }
  &.cursorPointer {
    cursor: default;
  }

  &.haccp-table {
    gap: 8px;

    > div {
      min-width: 0;
    }

    .checkbox_table {
      margin-right: 8px;
    }

    > div:nth-child(2) {
      flex: 1;
    }

    > div:last-child {
      margin-left: auto;
      text-align: left;
    }

    > div:hover {
      white-space: nowrap;
      display: block;
      height: 20px;
      word-break: normal;
      overflow-wrap: normal;
      hyphens: none;
    }
  }

  &.equipment-table-master {
    @media screen and (max-width: 960px) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "data1  data3 data5"
        "data2 data4 data6";
      padding-left: 5px;
      font-size: 13px;
    }
    @media (max-width: 600px) {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        "data1 data4"
        "data2 data5"
        "data3 data6";
    }
  }

  &.equipment-table {
    @media screen and (max-width: 960px) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title data4 data8 more-button"
        "data1 data5 data9 data"
        "data2 data6 data10 data"
        "data3 data7 data11 data";
      padding-left: 5px;
      font-size: 13px;
    }
    @media (max-width: 600px) {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        "title data4 more-button"
        "data1 data5 data"
        "data2 data6 data"
        "data3 data7 data"
        "data10 data8 data"
        "data9 data11 data";
    }
  }

  &.equipment-table-suport {
    @media screen and (max-width: 960px) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title data4 data8 more-button"
        "data1 data5 data9 data"
        "data2 data6 data data"
        "data3 data7 data data";
      padding-left: 5px;
      font-size: 13px;
    }
    @media (max-width: 600px) {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        "title data4 more-button"
        "data1 data5 data"
        "data2 data6 data"
        "data3 data7 data"
        "data10 data8 data"
        "data9 data11 data";
    }
  }

  @media screen and (max-width: 960px) {
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 10px;
    grid-template-rows: 20px 20px 20px;
    grid-template-areas:
      "title title data2 more-button"
      "data1 data5 data3 data3"
      "data4 data6 data7 data7";
    padding-left: 5px;
    font-size: 13px;

    &#table-equipments {
      grid-template-columns: 0.5fr 1.5fr 1fr 1fr 1fr 0;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 data2 data3 data4";

      @media screen and (max-width: 500px) {
        padding: 8px 0px;
        grid-template-columns: 0.7fr 1fr 1fr 1fr 1fr 0;
      }
    }

    &#table-equipments-home {
      grid-template-columns: 0.7fr 1.4fr 1fr 0.5fr 0 0;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 data2 data5 data3 data4";
    }
    &#table-equipments-errorSerious {
      grid-template-columns: 1fr 1fr 1.8fr 1.8fr 3fr;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 data2 data3 data4";
    }
    &#table-update-equipments {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 data2 data3 data4 data5";
    }
    &#recipes-executions {
      width: 100%;
      grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.2fr) minmax(0, 0.9fr);
      grid-template-areas: "title data1 data2";
      column-gap: 12px;
      padding: 8px 12px;
      align-items: center;

      > div:nth-child(4),
      > div:nth-child(5) {
        display: none;
      }
    }
    &#error-logs {
      width: 100%;
      grid-template-columns: minmax(0, 2.2fr) minmax(0, 1fr) minmax(0, 1fr);
      grid-template-rows: 20px;
      grid-template-areas: "title data1 hour";
      column-gap: 12px;
      padding: 8px 4px;
      align-items: center;

      > div:nth-child(2),
      > div:nth-child(3) {
        padding-left: 8px;
      }
    }
    &#baking-station-oven-table,
    &#baking-station-proofer-table {
      width: 100%;
      grid-template-columns: minmax(0, 1fr) 80px 44px;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 hour";
      column-gap: 12px;
      padding: 8px 20px;
      align-items: center;

      > div {
        width: auto;
        min-width: 0;
        padding-left: 0;
        margin-right: 0;
        font-size: 12px;
      }

      > div:last-child {
        text-align: right;
      }

      > div:nth-child(2),
      > div:nth-child(3) {
        overflow: visible;
        text-overflow: clip;
        white-space: nowrap;
      }
    }
    &#cleaning-executions {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 20px;
      grid-template-areas: "date hour";
      column-gap: 8px;
      padding: 8px 20px;
    }
    &#cleaning-executions-tsi {
      grid-template-columns:
        minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.05fr)
        minmax(0, 1.05fr);
      grid-template-rows: 20px;
      grid-template-areas: "done recommended date hour";
      column-gap: 8px;
      padding: 8px 20px;
    }
    &#cleaning-executions-support {
      grid-template-columns:
        minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.5fr)
        minmax(0, 0.6fr) minmax(0, 1.05fr) minmax(0, 1.05fr);
      grid-template-rows: 20px;
      grid-template-areas: "done recommended liters kwh date hour";
      padding: 8px 20px;
      column-gap: 6px;
    }
    &#haccp-history {
      grid-template-columns: 26px minmax(0, 1fr);
      grid-template-rows: auto auto;
      grid-template-areas:
        "more-button title"
        "data1 data1";
      row-gap: 4px;
      column-gap: 10px;
      padding: 8px 12px;
      align-items: start;

      &.is-expanded {
        row-gap: 6px;
      }
    }
    &#water-consumption-table,
    &#energy-consumption-table {
      height: auto;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto auto auto auto;
      grid-template-areas:
        "recipe"
        "consumption"
        "execDay"
        "execWeek"
        "execMonth";
      row-gap: 8px;
      padding: 10px 12px;
    }
    &#details-equipment {
      min-height: 32px;
      padding: 6px 20px;
      grid-template-columns: minmax(0, 1fr) 70px 45px;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 hour";

      > div:last-child {
        justify-self: end;
        text-align: right;
      }
    }
    &#table-equipments-support {
      grid-template-columns: 1fr 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title data2 more-button"
        "data1 data5 data3 data9"
        "data4 data6 data7 data8";
    }

    &.menu-table {
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title title title more-button"
        "data1 data3 data3 data3"
        "data4 data5 data7 data7";
    }

    &.menu-table > div:nth-child(7) {
      display: none;
    }

    &.trash-menu-table > div:nth-child(2),
    &.trash-menu-table > div:nth-child(3),
    &.trash-menu-table > div:nth-child(4) {
      display: none;
    }

    &.trash-menu-table {
      /* grid-template-columns: minmax(0, 1fr) 24px; */
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title title title more-button"
        "data4 data4 data4 data4"
        "data5 data5 data5 data5";
    }

    &.trash-menu-table > div:nth-child(5) {
      height: auto;
      white-space: normal;
      line-height: 18px;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr 1fr 10px;
    grid-template-rows: 20px 20px 20px 20px;
    grid-template-areas:
      "title data2 more-button"
      "data1 data3 data3"
      "data4 data5 data5"
      "data 6 data7 data7";

    &#details-equipment {
      padding: 6px 20px;
      grid-template-columns: minmax(0, 1fr) 70px 45px;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 hour";
    }
    &#table-equipments-support {
      grid-template-columns: 1fr 1fr 10px;
      grid-template-rows: 20px 20px 20px 20px;
      grid-template-areas:
        "title data2 more-button"
        "data1 data3 data3"
        "data4 data5 data9"
        "data6 data7 data8";
    }

    &.menu-table {
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title title more-button"
        "data1 data3 data3"
        "data4 data5 data7";
    }

    &.menu-table > div:nth-child(7) {
      display: none;
    }

    &.trash-menu-table > div:nth-child(2),
    &.trash-menu-table > div:nth-child(3),
    &.trash-menu-table > div:nth-child(4) {
      display: none;
    }

    &.trash-menu-table {
      /* grid-template-columns: minmax(0, 1fr) 24px; */
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title title more-button"
        "data4 data4 data4"
        "data5 data5 data5";
    }

    &.trash-menu-table > div:nth-child(5) {
      height: auto;
      white-space: normal;
      line-height: 18px;
    }
  }
  @media (max-width: 420px) {
    &#details-equipment {
      padding: 6px 20px;
      grid-template-columns: minmax(0, 1fr) 70px 45px;
      grid-template-rows: 20px;
      grid-template-areas: "title data1 hour";
    }
  }

  @media screen and (max-width: 480px) {
    &.menu-table {
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title title more-button"
        "data1 data3 data3"
        "data4 data5 data7";
    }

    &.menu-table > div:nth-child(7) {
      display: none;
    }

    &.trash-menu-table > div:nth-child(2),
    &.trash-menu-table > div:nth-child(3),
    &.trash-menu-table > div:nth-child(4) {
      display: none;
    }

    &.trash-menu-table {
      /* grid-template-columns: minmax(0, 1fr) 24px; */
      grid-template-rows: 20px 20px 20px;
      grid-template-areas:
        "title title more-button"
        "data4 data4 data4"
        "data5 data5 data5";
    }

    &.trash-menu-table > div:nth-child(5) {
      height: auto;
      white-space: normal;
      line-height: 18px;
    }
  }

  @media screen and (max-width: 960px) {
    &.location-table {
      grid-template-columns: minmax(0, 1fr) auto 24px;
      grid-template-rows: auto auto auto;
      grid-template-areas:
        "title title more-button"
        "data1 data1 data1"
        "data2 data2 data2";
      row-gap: 6px;
      align-items: start;
    }
  }
`;

export const ExpandedRow = styled.div<RowProps>`
  background-color: ${(props) => props.theme.colors.backgroundTable};
  padding: 0 20px 12px 56px;
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.colors.boxGroupBorder};

  &.haccp-table {
    padding: 0 20px 12px 56px;
  }

  &.even {
    background-color: transparent;
  }

  @media screen and (max-width: 960px) {
    padding: 0 12px 12px 20px;

    #haccp-history & {
      padding: 0 12px 12px 48px;
    }
  }
`;
type DataProps = {
  gridArea: string;
  width: string;
};
export const Data = styled.div<DataProps>`
  width: ${(props) => props.width};
  height: 20px;
  min-width: 0;
  box-sizing: border-box;
  text-align: left;
  grid-area: ${(props) => props.gridArea};
  text-overflow: ellipsis;
  overflow: hidden;

  :hover {
    white-space: normal;
    display: flex;
    align-content: center;
    height: auto;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
  }
  @media screen and (max-width: 960px) {
    .equipment-table &:hover,
    .stores-table &:hover {
      display: block;
      height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: normal;
      overflow-wrap: normal;
      hyphens: none;
    }

    .equipment-table &.with-indicator:hover,
    .stores-table &.with-indicator:hover {
      display: flex;
      align-items: center;
    }
  }
  .location-table &:hover {
    display: block;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: normal;
    overflow-wrap: normal;
    hyphens: none;
  }
  .haccp-table &,
  .haccp-table &:hover {
    white-space: nowrap;
    display: block;
    height: 20px;
    word-break: normal;
    overflow-wrap: normal;
    hyphens: none;
  }
  &.checkbox_table {
    //margin-right: 20px;
    width: 26px;
  }
  &.with-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }
  &.with-indicator:hover {
    align-items: flex-start;
  }
  &.more-icon,
  &.more-icon:hover {
    display: flex;
    align-items: center;
    height: 20px;
    overflow: visible;
    white-space: nowrap;
    word-break: normal;
    overflow-wrap: normal;
    hyphens: none;
  }
  img {
    width: 20px;
    margin-right: 20px;
  }
  .mobile-header {
    display: none;
  }

  #baking-station-oven-table &.title,
  #baking-station-proofer-table &.title {
    font-weight: 400;
  }

  @media screen and (max-width: 960px) {
    display: block;
    align-items: center;
    width: auto;
    padding-left: 10px;
    margin-right: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    &.title {
      font: normal normal bold 14px/20px Roboto;
      letter-spacing: 0.2px;
      color: ${(props) => props.theme.colors.textPrimary};
    }
    #recipes-executions & {
      padding-left: 0;
      height: auto;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 20px;
    }
    #cleaning-executions &,
    #cleaning-executions-tsi &,
    #cleaning-executions-support & {
      padding-left: 0;
      padding-right: 0;
      margin-right: 0;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 20px;
      font-size: 12px;
    }
    #details-equipment & {
      width: auto;
      min-width: 0;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
    }
    #error-logs & {
      padding-left: 4px;
      padding-right: 0;
      margin-right: 0;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 20px;
      font-size: 12px;
    }
    #error-logs &.title {
      font: normal normal 400 13px/20px Roboto;
      letter-spacing: 0;
    }
    #baking-station-oven-table &,
    #baking-station-proofer-table & {
      width: auto;
      min-width: 0;
      height: 20px;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      line-height: 20px;
    }
    #baking-station-oven-table &.title,
    #baking-station-proofer-table &.title,
    #baking-station-oven-table &.title:hover,
    #baking-station-proofer-table &.title:hover {
      display: block;
      height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font: normal normal 400 12px/20px Roboto;
      letter-spacing: 0;
    }
    #haccp-history & {
      padding-left: 0;
      padding-right: 0;
      margin-right: 0;
      min-width: 0;
      height: auto;
      line-height: 18px;
      font-size: 13px;
    }
    #haccp-history &.title {
      font: normal normal 400 14px/18px Roboto;
      letter-spacing: 0;
    }
    #haccp-history.is-expanded & {
      white-space: normal;
      overflow: visible;
      text-overflow: initial;
    }
    #haccp-history .checkbox_table {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding-top: 1px;
    }
    #water-consumption-table &,
    #energy-consumption-table & {
      height: auto;
      white-space: normal;
      overflow: visible;
      text-overflow: initial;
      line-height: 18px;
      padding-left: 0;
      display: block;
    }
    #water-consumption-table &.title,
    #energy-consumption-table &.title {
      font: normal normal 600 13px/18px Roboto;
    }
    &.more-icon {
      padding: 0;
      width: 30px;
      height: 30px;
    }
    &.checkbox_table {
      padding: 0;
    }
    .mobile-header {
      display: inline;
      font-weight: bold;
    }

    .location-table &.address-cell {
      height: auto;
      white-space: normal;
      overflow: visible;
      text-overflow: initial;
      line-height: 18px;
      word-break: break-word;
      overflow-wrap: anywhere;
    }
  }
`;

export const DataIcon = styled.div<DataProps>`
  width: ${(props) => props.width};
  text-align: left;
  grid-area: ${(props) => props.gridArea};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
  display: flex;
  align-content: center;

  &#download {
    overflow: visible;
    height: 20px;
    cursor: pointer;
  }

  &#alert {
    overflow: visible;
    height: 20px;
    cursor: pointer;
  }

  &#delete {
    overflow: visible;
    height: 30px;
    cursor: pointer;
  }

  &#edit {
    overflow: visible;
    height: 30px;
    cursor: pointer;
  }

  &.checkbox_table {
    width: 22px;
  }
  &.more-icon {
    overflow: initial;
  }
  img {
    margin-right: 20px;
  }

  @media screen and (max-width: 960px) {
    display: flex;
    align-items: center;
    width: auto;
    padding-left: 20px;
    &.title {
      font: normal normal bold 14px/20px Roboto;
      letter-spacing: 0.2px;
      color: ${Colors.LOW_PURE};
      text-transform: uppercase;
    }
    &.more-icon {
      padding: 0;
      width: 30px;
      height: 30px;
    }
    &.checkbox_table {
      display: none;
    }
  }
`;

export const OriginData = styled(DataIcon)`
  align-items: center;
  justify-content: flex-start;

  img {
    margin-right: 0;
    width: 20px;
    height: 20px;
  }

  .mobile-header {
    display: none;
  }

  @media screen and (max-width: 480px) {
    .mobile-header {
      display: inline;
      margin-right: 8px;
      font-weight: bold;
    }
  }
`;

export const TBody = styled.div<{ hideScrolllbar?: boolean }>`
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: ${(props) => (props.hideScrolllbar ? "hidden" : "auto")};

  &.history-mobile-table {
    flex: 0 0 auto;
    min-height: auto;
  }

  &.force-scroll {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
  }
`;

export const Tooltip = styled.div`
  visibility: hidden;
  background-color: white;
  color: #004992;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: bold;
  font-size: 12px;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  top: -20%;
  right: 110%;
  // transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
  border: 1px solid;
  border-color: #004992;

  &::after {
    content: "";
    position: absolute;
    top: 30%;
    right: 0;
  }
`;

export const IconWrapper = styled.div`
  display: inline-block;
  overflow: visible;
  position: relative;

  &:hover > ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }

  svg {
    fill: #5daeff;
  }
`;

const colorMap: { [key: string]: string } = {
  Online: "#31D146",
  Offline: "#767676",
  green: "#31D146",
  blue: "#5DAEFF",
  grey: "#767676",
  orange: "#E54529",
  red: "#C21618",
  yellow: "#EEAD2D",
  grey2: "#A6A6A6",
};

export const Ellipse = styled.div<{ status: string }>`
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  flex: 0 0 10px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ status }) => colorMap[status] || "transparent"};
  display: ${({ status }) => (status !== "-" ? "inline-block" : "none")};
  margin: 0 5px;
  vertical-align: middle;
`;

export const StatusText = styled.span`
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1 1 auto;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const StatusTextMenssage = styled.span`
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1 1 auto;

  .with-indicator:hover & {
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
  }
`;
